import React, { useEffect, useState } from 'react';
import {
  Input,
  Panel,
  DateRangePicker,
  Col,
  TagPicker,
  ButtonToolbar,
  Button,
  Stack,
  Message,
  FlexboxGrid,
  IconButton,
  InputPicker,
} from 'rsuite';
import SpinnerIcon from '@rsuite/icons/legacy/Spinner';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@rsuite/icons/Search';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
// import { useSelector, useDispatch } from 'react-redux';

import api from 'Components/_helpers/api';
import axios from 'axios';
import { FilterControl } from 'Components/Common/FilterControl';
import { useEmpresas } from 'Components/Common/CustomHooks/useEmpresas';

export const Filters = (props) => {
  const { limit, onFilter, recordsTotal, onDownloadData } = props;
  const [empresas, loadingData, featEmpresas] = useEmpresas();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      emisorNit: [],
      tipoEstablecimiento: [],
      fechaEmision: [],
      tipoDocReceptor: [],
      docReceptor: '',
      tipoOperacion: null,
      tipoContingencia: [],
      codigoGeneracion: '',
      numeroControl: '',
    },
  });

  const [catDefs, setCatDefs] = useState({ loading: true });

  const getCATDef = () => {
    const catTipoEstablecimiento = api.post(`${api.getUri()}CAT/CAT009`, { code: null });
    const catTipoDocumento = api.post(`${api.getUri()}CAT/CAT022`, { code: null });
    const catTipoContingencia = api.post(`${api.getUri()}CAT/CAT005`, { code: null });

    axios.all([catTipoEstablecimiento, catTipoDocumento, catTipoContingencia]).then(
      axios.spread((tipoEstablecimiento, tipoDocumento, tipoContingencia) => {
        setCatDefs({
          loading: false,
          tipoEstablecimiento: tipoEstablecimiento.data.items,
          tipoDocumento: tipoDocumento.data.items,
          tipoContingencia: tipoContingencia.data.items,
        });
      })
    );
  };

  // const onDownloadData = () => {
  //   fetch(`${api.getUri()}${tipoDte}/CSV`, {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json, text/plain',
  //       'Content-Type': 'application/json;charset=UTF-8',
  //     },
  //     body: JSON.stringify(currentFilter),
  //   })
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       fileDownload(blob, 'reporte.csv');
  //     });
  // };

  // const onDownloadZipData = () => {
  //   fetch(`${api.getUri()}${tipoDte}/ZipAll`, {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json, text/plain',
  //       'Content-Type': 'application/json;charset=UTF-8',
  //     },
  //     body: JSON.stringify(currentFilter),
  //   })
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       fileDownload(blob, 'DTE-Zip.zip');
  //     });
  // };

  const onSubmit = async (data) => {
    const filters = { 
      ...data, 
      desde: data.fechaEmision && data.fechaEmision[0] ? data.fechaEmision[0].toISOString() : null, 
      hasta: data.fechaEmision && data.fechaEmision[1] ? data.fechaEmision[1].toISOString() : null, 
      pagination: { NumberPage: 1, SizePage: limit } 
    };
    // Remove fechaEmision array to avoid storing Date objects in Redux
    delete filters.fechaEmision;
    onFilter(filters);
  };

  useEffect(() => {
    getCATDef();
  }, []);

  return (
    <div style={{ paddingBottom: 10 }}>
      <Panel
        header={
          <Message showIcon type="info" header={`Filtros aplicados a la tabla de DTEs (${recordsTotal} Resultados)`}>
            Click aquí para ver los filtros aplicados a esta tabla de documentos DTE
          </Message>
        }
        collapsible
        bordered
      >
        <FlexboxGrid>
          <FlexboxGrid.Item as={Col} colspan={24} lg={14}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={12} direction={'column'} alignItems="stretch" style={{ paddingBottom: 10 }}>
                <FilterControl
                  desc={'Fecha de emisión:'}
                  control={
                    <Controller
                      name="fechaEmision"
                      control={control}
                      render={({ field }) => <DateRangePicker block {...field} placeholder="Selecciona fecha de emisión" />}
                    />
                  }
                />
                <FilterControl
                  desc={'Emisor:'}
                  control={
                    <InputPicker
                      data={empresas}
                      placeholder="Selecciona el emisor al que corresponde el certificado"
                      block
                      valueKey="emisor"
                      onSearch={featEmpresas}
                      renderMenu={(menu) => {
                        if (loadingData) {
                          return (
                            <p style={{ padding: 10, color: '#999', textAlign: 'center' }}>
                              <SpinnerIcon spin /> Buscando...
                            </p>
                          );
                        }
                        return menu;
                      }}
                    />
                  }
                />
                <FilterControl
                  desc={'Tipo de establecimiento:'}
                  control={
                    <Controller
                      name="tipoEstablecimiento"
                      control={control}
                      render={({ field }) => (
                        <TagPicker
                          block
                          {...field}
                          loading={catDefs.loading}
                          data={catDefs.loading ? [] : catDefs.tipoEstablecimiento.map((c) => ({ label: c.value, value: c.code }))}
                          placeholder="Tipo de establecimiento del emisor"
                        />
                      )}
                    />
                  }
                />
                <FilterControl
                  desc={'Tipo de documento del receptor:'}
                  control={
                    <Controller
                      name="tipoDocReceptor"
                      control={control}
                      render={({ field }) => (
                        <TagPicker
                          block
                          {...field}
                          loading={catDefs.loading}
                          data={catDefs.loading ? [] : catDefs.tipoDocumento.map((c) => ({ label: c.value, value: c.code }))}
                          placeholder="Tipo de documento de identificación del receptor"
                        />
                      )}
                    />
                  }
                />
                <FilterControl
                  desc={'Núm. Documento del receptor:'}
                  control={
                    <Controller
                      name="docReceptor"
                      control={control}
                      render={({ field }) => <Input {...field} placeholder="Documento de identificación del receptor" />}
                    />
                  }
                />
                {/* <FilterControl
                  desc={'Tipo de transmición:'}
                  control={
                    <Controller
                      name="tipoOperacion"
                      control={control}
                      render={({ field }) => (                            
                        <SelectPicker
                          block
                          searchable={false}
                          {...field}
                          data={[
                            { label: 'Normal', value: 1 },
                            { label: 'Por Contingencia', value: 2 },
                          ]}
                          placeholder="Tipo de operación"
                        />
                      )}
                    />
                  }
                /> */}
                <FilterControl
                  desc={'Código de generación:'}
                  control={
                    <Controller
                      name="codigoGeneracion"
                      control={control}
                      render={({ field }) => <Input {...field} placeholder="Código de generación" />}
                    />
                  }
                />
                <FilterControl
                  desc={'Número de control:'}
                  control={
                    <Controller
                      name="numeroControl"
                      control={control}
                      render={({ field }) => <Input {...field} placeholder="Número de control" />}
                    />
                  }
                />
                <ButtonToolbar>
                  <IconButton icon={<SearchIcon />} appearance="primary" type="submit">
                    Buscar
                  </IconButton>
                  <IconButton
                    icon={<FileDownloadIcon />}
                    appearance="primary"
                    onClick={onDownloadData}
                  >
                    Descargar resultados (.xlsx)
                  </IconButton>
                  {/* <IconButton
                    icon={<FileDownloadIcon />}
                    appearance="primary"
                    onClick={onDownloadData}
                    disabled={!(documentsData.recordsTotal !== 0)}
                  >
                    Descargar resultados (.csv)
                  </IconButton>
                  <IconButton
                    icon={<FileDownloadIcon />}
                    appearance="primary"
                    onClick={onDownloadZipData}
                    disabled={!(documentsData.recordsTotal !== 0)}
                  >
                    Descargar resultados (.zip)
                  </IconButton> */}
                  <Button
                    appearance="ghost"
                    color="red"
                    onClick={() => {
                      reset((formValues) => ({
                        ...formValues,
                        fechaEmision: [],
                        docReceptor: '',
                        tipoOperacion: null,
                        codigoGeneracion: '',
                        numeroControl: '',
                      }));
                      onFilter({ pagination: { NumberPage: 1, SizePage: limit } });
                    }}
                  >
                    Limpiar parametros
                  </Button>
                </ButtonToolbar>
              </Stack>
            </form>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} lg={10}>
            <div>
              <label style={{ fontSize: 20 }}>{recordsTotal} Resultados</label>
            </div>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Panel>
    </div>
  );
};
